import { ConfigProvider, Form, Input, message, Modal } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { FeeLadderLevelRepo } from "@/core/repos/tables/fee-ladder-level.repo";
import { FeeLadderLevelModel } from "@/core/models/fee-ladder-level.model";
import { usePermissionStore } from "@/core/stores/permission.store";
import { SaveButton } from "@/app/home/components/table/SaveButton";

const feeLadderLevelRepo = container.get(FeeLadderLevelRepo);

interface DetailModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: FeeLadderLevelModel,
}

const INPUT_WIDTH = 450;

export const DetailModal: React.FC<DetailModalProps> = ({isModalOpen, setIsModalOpen, data}) => {
    const permissionStore = usePermissionStore();
    const [form] = Form.useForm<FeeLadderLevelModel>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();   
    // Attach hooks to handle data changes
    const handleDataChange = async () => {
        form.setFieldsValue(data);
        if (data.id && data.id.length > 0) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
    }
    useEffect(() => {
        handleDataChange();
    }, [data])

    // Initialize select options data
    const init = async () => {
        // await populateSelections();
    }
    // componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);


    const handleSave = async () => {
        setLoading(true);
        try {
            const formData = await form.validateFields();
            const response = await feeLadderLevelRepo.save({ ...data, ...formData, id: data.id });
            if (response.code === "00") {
                messageApi.success({ content: isEdit ? "Đã cập nhật bản ghi" : "Thêm bản ghi mới thành công" });
                setIsModalOpen(false);
            } else {
                if (response.errors) {
                    form.setFields(Object.entries(response.errors).map(([name, errors]) => ({ name: name as keyof FeeLadderLevelModel, errors })));
                }
                messageApi.error({ content: response.errorMessage || "Không thể lưu bậc giá. Vui lòng kiểm tra lại thông tin." });
            }
        } catch (error) {
            // AntD already displays local validation failures beside their fields.
            if (!error || typeof error !== "object" || !("errorFields" in error)) {
                messageApi.error({ content: "Không thể lưu bậc giá. Vui lòng thử lại." });
            }
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal open={isModalOpen} onCancel={handleCancel} width={500} centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <SaveButton isEdit={isEdit} loading={loading} onClick={handleSave}/>
                    </div>,
            ]}>
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">CHI TIẾT BẬC GIÁ</p>
                </div>
                <div className="flex flex-row justify-center mt-2">
                    <Form<FeeLadderLevelModel>
                        name="basic"
                        className="flex flex-col items-end"
                        form={form}
                        layout="vertical"
                        disabled={isEdit&&!permissionStore.page.edit}
                    >
                        <Form.Item<FeeLadderLevelModel>
                            label="Mã bậc giá"
                            name="code"
                        >
                            <Input placeholder="Nhập mã bậc giá" style={{width: INPUT_WIDTH}} />
                        </Form.Item>

                        <Form.Item<FeeLadderLevelModel>
                            label="Tên"
                            name="name"
                            rules={[{ required: true, message: 'Bạn phải chọn Tên!' }]}
                        >
                            <Input placeholder="Nhập tên" style={{width: INPUT_WIDTH}}></Input>
                        </Form.Item>

                        <Form.Item<FeeLadderLevelModel>
                            label="Chỉ số từ"
                            name="fromAmount"
                            rules={[{ required: true, message: 'Bạn phải chọn Chỉ số từ!' }]}
                        >
                            <Input type="number" placeholder="Nhập Chỉ số từ" style={{width: INPUT_WIDTH}}></Input>
                        </Form.Item>

                        <Form.Item<FeeLadderLevelModel>
                            label="Chỉ số đên"
                            name="toAmount"
                            rules={[{ required: true, message: 'Bạn phải chọn Chỉ số đên!' }]}
                        >
                            <Input type="number" placeholder="Nhập Chỉ số đên" style={{width: INPUT_WIDTH}}></Input>
                        </Form.Item>

                        <Form.Item<FeeLadderLevelModel>
                            label="Giá bán"
                            name="price"
                            rules={[{ required: true, message: 'Bạn phải chọn Giá bán!' }]}
                        >
                            <Input  type="number" placeholder="Nhập Giá bán" style={{width: INPUT_WIDTH}}></Input>
                        </Form.Item>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
}
